import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const useSettingsValidation = () => {
  const { t } = useTranslation(['settings', 'auth']);
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    if (!email) return t('auth:errors.required_field');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return t('auth:errors.invalid_email_format');
    return null;
  };

  const validatePhone = (formData) => {
    // Vérifier si nous avons un objet phone dans formData
    const phoneData = formData.phone || {};
    
    if (!phoneData.phone) return t('auth:errors.required_field');
    if (!phoneData.phoneVerified) return t('settings:errors.phone_not_verified');
    return null;
  };

  const validateDisplayName = (name) => {
    if (!name?.trim()) return t('auth:errors.required_field');
    if (name.length < 2) return t('settings:errors.name_too_short');
    return null;
  };

  const validateLocation = (location) => {
    if (!location) return t('auth:errors.required_field');
    if (!location.placeId || !location.address) {
      return t('settings:errors.invalid_location');
    }
    return null;
  };

  const validateForm = (formData) => {
    const newErrors = {};

    const nameError = validateDisplayName(formData.displayName);
    if (nameError) newErrors.displayName = nameError;

    const emailError = validateEmail(formData.email);
    if (emailError) newErrors.email = emailError;

    const phoneError = validatePhone(formData);
    if (phoneError) newErrors.phone = phoneError;

    const locationError = validateLocation(formData.location);
    if (locationError) newErrors.location = locationError;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return {
    errors,
    validateForm,
    clearErrors: () => setErrors({}),
    setFieldError: (field, error) => setErrors(prev => ({ ...prev, [field]: error }))
  };
}; 